export enum AUTH_ENDPOINT {
  LOGIN = "auth/login",
  REGISTER = "auth/register",
  REFRESHTOKEN = "auth/refresh",
  GET_SERIAL = "auth/serial",
  UPDATE_BADGE = "auth/badge",
  GET_PROFILE = "auth/profile"
}